'use client';
import { FC, useMemo, useState } from 'react';
import Typography from '@/components/shared/typography/typography.component';
import { useTranslation } from '@/hook';
import styles from './styles.module.scss';
import WhatsIncluedItem from './whats-included-item/whats-included-item.component';
import colors from '@/theme/colors.module.scss';
import Image from 'next/image';
import { X } from '../../../../public/Images';
import { whatsIncludedContent } from '@/constants';
import { IWhatsIncludedItem } from '@/types';

const WhatsIncludedPopUp: FC<{
    open: boolean;
    setOpen: (flag: boolean) => void;
    registrationFees?: number | null;
}> = ({ open, setOpen, registrationFees }) => {
    const { t } = useTranslation();
    const [keyIndex, setKeyIndex] = useState(0);
    const generatedContent = useMemo<IWhatsIncludedItem[]>(() => {
        return whatsIncludedContent.map(item => {
            setKeyIndex(keyIndex + 1);
            const props: IWhatsIncludedItem = { title: t(item.title) };
            if (item.subtitle) props.subtitle = t(item.subtitle);
            if (item.content && item.content.length)
                props.content = item.content.map(listItem => t(listItem));
            if (item.price) props.price = registrationFees;
            props.expandedDefault = item.expandedDefault === true;
            if (item.price) props.price = registrationFees;
            props.expandedDefault = item.expandedDefault === true;
            return props;
        });
    }, [open]);

    return (
        <div className={styles.popUpContainer}>
            <div className={styles.popUpContainerHeader}>
                <Typography variant="subtitle2Medium" color={colors.gray900}>
                    {t('whatsIncluded.title')}
                </Typography>
                <Image
                    src={X}
                    width={10}
                    height={10}
                    alt={'close'}
                    onClick={() => setOpen(false)}
                />
            </div>
            <div className={styles.popUpContainerList}>
                {generatedContent.map((item, index) => (
                    <WhatsIncluedItem
                        {...item}
                        key={`${index}_item_${keyIndex}`}
                    />
                ))}
            </div>
        </div>
    );
};

export default WhatsIncludedPopUp;
